// import FidgetSpinnerAddOnBoxClass from './addons/fidgetSpinner'
import InformationAddOnBoxClass from './addons/info'
import LastVisitedAddOnBoxClass from './addons/lastClosedList'
import LearningTricksAddOnBoxClass from './addons/learningTricks'
import PreferencesAddOnBoxClass from './addons/preferences'
import SharedNodesAddOnBoxClass from './addons/sharedNodes'
import StatisticsAddOnBoxClass from './addons/sharing/statistics'
import SnakeAddOnBoxClass from './addons/snake'
import TodoListAddOnBoxClass from './addons/todolist'
import UploadType1BoxClass from './addons/uploadType1'
import { InsertFormBoxClassArray } from './addons/parts/forEachInsertForm/generatingBoxClasses'
import PixelModeControlPadAddOnBoxClass from './addons/pixelModeControlPad'
// import DocumentAddOnBoxClass from './dummies/document'
// import FromMobileAddOnBoxClass from './dummies/fromMobileApp'
import SpreadsheetAddOnBoxClass from './addons/spreadsheet-like'
import UploadType2AddOnBoxClass from './addons/uploadType2'
import NodeInformationAddOnBoxClass, { NoteInformationAddOnBoxClass } from './addons/nodeInfo'
import DataAddOnBoxClass from './addons/Data'
import AnkiAddOnBoxClass from './addons/anki'
import SearchAddOnBoxClass from './addons/search'
import RemovedNodesAddOnBoxClass from './addons/removedNodes'
import BookmarksAddOnBoxClass from './addons/bookmarks'
import CourseStatusAddOnBoxClass from './addons/courseStatus'
import AppInfoAddOnBoxClass from './addons/sharing/appInfo'
import SharingInfoAddOnBoxClass from './addons/sharing/sharingInfo'
import ExportAtSharingAddOnBoxClass from './addons/sharing/export'

export const AddOnArray = [
  InformationAddOnBoxClass, LastVisitedAddOnBoxClass, PreferencesAddOnBoxClass, TodoListAddOnBoxClass, NodeInformationAddOnBoxClass, SearchAddOnBoxClass, RemovedNodesAddOnBoxClass, BookmarksAddOnBoxClass,
  UploadType1BoxClass, PixelModeControlPadAddOnBoxClass, SpreadsheetAddOnBoxClass, UploadType2AddOnBoxClass, DataAddOnBoxClass, AnkiAddOnBoxClass, SnakeAddOnBoxClass,
  CourseStatusAddOnBoxClass, SharedNodesAddOnBoxClass, NoteInformationAddOnBoxClass, LearningTricksAddOnBoxClass,
  // SampleInsertAddOnBoxClass
  AppInfoAddOnBoxClass, SharingInfoAddOnBoxClass, ExportAtSharingAddOnBoxClass, StatisticsAddOnBoxClass
]

const AddOnArray1 = []
const AddOnArray2 = []
const AddOnArray3 = []
const AddOnArrayFavorite = []
const AddOnArraySharing = []

for (let i = 0; i < AddOnArray.length; i++) {
  const oneBoxClass = AddOnArray[i]

  switch (oneBoxClass.role) {
    case 1:
      AddOnArray1.push(oneBoxClass)
      break
    case 2:
      AddOnArray2.push(oneBoxClass)
      break
    case 3:
      AddOnArray3.push(oneBoxClass)
      break
    case 'sharing':
      AddOnArraySharing.push(oneBoxClass)
      break
    default:
      throw (new Error('boxclass 안에 role이 123이 아님'))
  }
  if (oneBoxClass.inSharingMode) {
    AddOnArraySharing.push(oneBoxClass)
  }
  // if (oneBoxClass.isFavorite) {
  //   AddOnArrayFavorite.push(oneBoxClass)
  // }
}

AddOnArray2.push(...InsertFormBoxClassArray)
AddOnArray.push(...InsertFormBoxClassArray)
// -----------------------------------------------------------------------------------------------------------

export function registerToFavoriteArray () {
  AddOnArrayFavorite.length = 0
  for (let i = 0; i < AddOnArray.length; i++) {
    const oneBoxClass = AddOnArray[i]
    if (oneBoxClass.isFavorite) {
      AddOnArrayFavorite.push(oneBoxClass)
    }
  }
}

// -----------------------------------------------------------------------------------------------------------

export { AddOnArray1, AddOnArray2, AddOnArray3, AddOnArrayFavorite, AddOnArraySharing }
